import { useQuery } from "react-query";
import { cacheKeys } from "../../../service/api";
import { apiKeysHttp } from "./api-keys-http";

export const useGetApiKeys = (organizationKeyName?: string) => {
  return useQuery(
    [cacheKeys.apiKeys],
    () => apiKeysHttp.getApiKeys(organizationKeyName),
    { refetchOnWindowFocus: false }
  );
};
